// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4126a217","455":"bd8ac6b4"}[chunkId] + ".chunk.js";
};